export default {
    updatePosts(state, payload) {
        if (payload.tipo == 'novedades'){
            state.novedades = payload.posts
        }
        if (payload.tipo == 'articulos'){
            //console.log(payload.posts)
            state.articulos = payload.posts
        }
        if (payload.tipo == 'proyectos'){
            //console.log(payload.posts)
            state.proyectos = payload.posts
        }
        if (payload.tipo == 'testimonios'){
            state.testimonios = payload.posts
        }
        if (payload.tipo == 'conceptos'){
            state.conceptos = payload.posts
        }
        if (payload.tipo == 'espacios'){
            state.espacios = payload.posts
        }
        if (payload.tipo == 'ludiculas'){
            state.ludiculas = payload.posts
        }
    },
    updatePage(state, payload) {
        //console.log(payload)
        if (payload.slug.toLowerCase() == 'quienes-somos'){
            //console.log(payload)
            state.nosotrxs = payload
        } else if (payload.slug.toLowerCase() == 'encuentro') {
            state.encuentro = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2022') {
            state.encuentro2022 = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2024') {
            state.encuentro2024 = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2024vivo') {
            state.encuentro2024vivo = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2024programa') {
            state.encuentro2024programa = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2026') {
            state.encuentro2026 = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2026vivo') {
            state.encuentro2026vivo = payload
        } else if (payload.slug.toLowerCase() == 'encuentro2026programa') {
            state.encuentro2026programa = payload
        } else if (payload.slug.toLowerCase() == 'encuentro-declaraciones') {
            state.declaraciones = payload            
        } else if (payload.slug.toLowerCase() == 'encuentro-recorrido') {
            state.recorrido = payload            
        }
    },

    updateCategorias(state, payload) {
        if (payload.tipo == 'ludiculas-categorias'){
            //console.log(payload.tipo)
            let padres = [];
            let hijas = [];
            //console.log('categorias:',payload.categorias)
            payload.categorias.forEach(cat => {
                //console.log(cat)
                if (cat.parent == 'padre'){
                    padres.push(cat);
                } else {
                    hijas.push(cat);
                }
            });
            // console.log(hijas)
            // console.log(padres)
            let categoriasAgrupadas = [];
            let categoriasAgrupadasID = [];
            let categoriasGroupID = [];
            let categoriaGrupoID = {};
            let categoriasGrupo = [];
            let categoriaGrupo = {};

            padres.forEach(catP => {
                categoriasGrupo = [];
                categoriaGrupo = {};
                categoriasGroupID = [];
                categoriaGrupoID = {};

                categoriasGrupo = hijas.filter(
                    (cat) => cat.parent == catP.id
                );
                //console.log(categoriasGrupo)
                categoriasGrupo.forEach(categoria => {categoriasGroupID.push(categoria.id)})

                if (categoriasGrupo.length > 0){
                    categoriaGrupo.catPadre = catP;
                    categoriaGrupo.categorias = categoriasGrupo;
                    categoriasAgrupadas.push(categoriaGrupo)
                    categoriaGrupoID.catPadre = catP.id;
                    categoriaGrupoID.categorias = categoriasGroupID;
                    categoriasAgrupadasID.push(categoriaGrupoID)
                }

            })
            // console.log(hijas)
            // console.log(categoriasAgrupadasID)
            state.ludCategorias = payload.categorias
            state.ludCategoriasPadres = padres
            state.ludCategoriasHijas = hijas
            state.ludCategoriasHijasID = categoriasAgrupadasID
        } else if (payload.tipo == 'ludiculas-tags'){
                //let padre;
                let padres = [];
                let hijas = [];
                //console.log('categorias:',payload.categorias)
                payload.categorias.forEach(tag => {
                    if (tag.parent == 'padre'){
                        padres.push(tag);
                    } else {
                        hijas.push(tag);
                    }
                });

                let categoriasAgrupadas = [];
                let categoriasGrupo = [];
                let categoriaGrupo = {};

                padres.forEach(catP => {
                    categoriasGrupo = [];
                    categoriaGrupo = {};
                    categoriasGrupo = hijas.find(
                        (cat) => cat.parent == catP.id
                    );
                    if (categoriasGrupo){
                        categoriaGrupo.catPadre = catP;
                        categoriaGrupo.categorias = categoriasGrupo;
                        categoriasAgrupadas.push(categoriaGrupo)
                    }
                })
                //console.log(categoriasAgrupadas)
                //console.log(padres)
                state.ludTags = payload.categorias
                state.ludTagsPadres = padres 
                state.ludTagsHijas = categoriasAgrupadas 
        } else if (payload.tipo == 'nombres-tags'){
           // console.log(payload)
            state.otrosNombres = payload.categorias; 
        }
    },

    updateFiltros(state, payload) {
        //console.log(payload)
        if (!payload.tipo){
            //console.log('borrar')
            state.ludFiltrosCategorias = []
            state.ludFiltrosTags = []
        } else{
            if (payload.tipo == 'categoria'){
                //console.log('update: ', payload.filtros)
                state.ludFiltrosCategorias = payload.filtros
            } else if (payload.tipo == 'etiqueta'){
                //console.log('update: ', payload.filtros)
                state.ludFiltrosTags = payload.filtros
            } 
        }
    }
}